import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import AddPlayer from '../../components/AddPlayer';
import Request, { ApiMode } from '../../utils/request';

const SELECTOR_MAIN_DIV = '.p-edit-linked-account-details';
const SELECTOR_ADD_PLAYER_COMPONENT = '.lta-add-player';

const CLICK_EVENT = 'click';

const IS_LOCAL = false;

class LinkedEditChildAccountsDetails {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_MAIN_DIV);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	init() {
		this.navigationBackButtons = SelectorEngine.find('.js-account-edit-back', this._wrapper);
		this.addPlayerComponent = SelectorEngine.findOne(SELECTOR_ADD_PLAYER_COMPONENT, this._wrapper);

		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (params.playerId) {
			this.playerId = params.playerId;
		}

		for (const button of this.navigationBackButtons) {
			EventHandler.on(button, CLICK_EVENT, (event) => {
				this.goToUrl(event);
			});
		}
		this.fetchPlayersList(this.playerId);
	}

	async fetchPlayersList(playerID) {
		try { 
			const url = `/api/player/getplayers`;
			const response = await Request.get(url, {}, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
			}
			});
			const { playerDetails, error } = response;
			if(playerDetails) {
				const playerDetail = playerDetails.find((playerObject) => playerObject.id == playerID);
				if(playerDetail) {
					this.addPlayer = new AddPlayer(this.addPlayerComponent);
					this.addPlayer.isAddPlayer = false;
					this.addPlayer.playerData = playerDetail;
				}
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				console.log("Error : ", error);
			}
		}
	}
	goToUrl(event, redirectUrl) {
		const rootUrl = window.location.origin;
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}
}

const globalLinkedEditChildAccountsDetails = new LinkedEditChildAccountsDetails();
export default globalLinkedEditChildAccountsDetails;
